import axios from 'axios'
import { DATAMASTER_ENDPOINT } from 'common/endpoints'

export async function getHistoryPrice(args) {
    //args = version del auto 
    try {
        const {data} = await axios.get(DATAMASTER_ENDPOINT + `/${args}/referencePrices`)        
            return data;

    } catch (error){
        return error
    }    
}
